import { render, staticRenderFns } from "./ModalDeletePersonalizationSet.vue?vue&type=template&id=2f34a99a&scoped=true"
import script from "./ModalDeletePersonalizationSet.vue?vue&type=script&lang=js"
export * from "./ModalDeletePersonalizationSet.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletePersonalizationSet.vue?vue&type=style&index=0&id=2f34a99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34a99a",
  null
  
)

export default component.exports